import { animated, useTransition } from '@react-spring/web';
import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';
import { Icon } from '../Icon';
import { Checkmark } from '../Icons';
const AbsoluteIcon = styled(animated(Icon)).attrs(props => ({
  style: {
    top: props !== null && props !== void 0 && props.top ? props.top : '15px',
    right: props !== null && props !== void 0 && props.right ? props.right : '18px'
  }
})).withConfig({
  displayName: "AbsoluteIcon",
  componentId: "sc-1ope3sj-0"
})(["&&&{position:absolute;}"]);
const transitionConfig = {
  from: {
    opacity: 0,
    transform: 'scale(0.9)'
  },
  enter: {
    opacity: 1,
    transform: 'scale(1)'
  },
  leave: {
    opacity: 0,
    transform: 'scale(0.9)'
  }
};
export const ValidCheckmark = React.memo(function ValidCheckmark(_ref) {
  let {
    isValid,
    top,
    right
  } = _ref;
  const iconTransition = useTransition(isValid, transitionConfig);
  return iconTransition((style, item) => item && React.createElement(AbsoluteIcon, {
    top: top,
    right: right,
    style: style,
    color: "feeling.positive"
  }, React.createElement(Checkmark, null)));
});
ValidCheckmark.propTypes = process.env.NODE_ENV !== "production" ? {
  isValid: PropTypes.bool
} : {};
ValidCheckmark.defaultProps = {
  isValid: false
};